import { ConfigProvider, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
// import { AuthContext } from "../providers/AuthProvider";
import { useContext } from "react";
// import { useGetConstantsQuery } from "../redux/services/constants";
// import { navIcons } from "../assets/navigation-icons";
import { CustomIcon } from "../utils";
import { navIcons } from "../assets/navigation-icons";

const menuItems = [
  {
    label: "My Tenants",
    key: "/tenants",
    icon: <CustomIcon svg={navIcons.Activity} />,
  },

  {
    label: "Users",
    key: "/users",
    icon: <CustomIcon svg={navIcons.Config} />,
  },
  {
    label: "Profile",
    key: "/profile",
    icon: <CustomIcon svg={navIcons.Config} />,
  },
];

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClick = (e) => {
    e.key !== null && navigate(e.key);
  };
  // const getMenuItemsList = () => {
  //   if (isKarbonWiseAdmin || isAccountOwner || isAccountStaff) {
  //     return isKarbonWiseAdminItems;
  //   } else if (isCompanyStaff) {
  //     return isCompanyStaffItems;
  //   } else {
  //     return isCompanyAdminItems;
  //   }
  // };

  // const { data } = useGetConstantsQuery({
  //   key: "APP_LOGO",
  // });

  return (
    // <Row>
    //   <Space
    //     direction="vertical"
    //     style={{
    //       width: "100%",
    //       height: "100%",
    //       justifyContent: "space-between",
    //     }}
    //   >
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          iconSize: 30,
          colorPrimary: "#00b96b",
          colorIcon: "red",
        },
        components: {
          Menu: {
            colorIcon: "green",
            size: "30px",
            fontSizeIcon: "50px",
            colorInfoActive: "red",
          },
        },
      }}
    >
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        onClick={onClick}
        items={menuItems}
        // selectable={false}
        style={{
          paddingBottom: "150px",
        }}
      />
    </ConfigProvider>
    //   </Space>
    // </Row>
  );
};
export default SideBar;
